import { getMetaContent } from "../lib/dom";
import * as Sentry from "@sentry/browser";

const dsn = getMetaContent("sentry-dsn");
if (dsn) {
  Sentry.init({
    dsn: dsn,
    environment: getMetaContent("sentry-env") || "production",
    integrations: [],
  });
}
